// Comms final pass: the strip a pull-to-refresh pane shows at its top while the finger pulls, and "Refreshing…" while it reloads.
// Sits inside the scroll pane as its first child, so it pushes the content down by exactly the pull. Reduced motion: no spin, no
// easing (styles in src/styles/step2n.css). The words are announced once through a polite live region that is always mounted.
import React from 'react';

const WORDS = {
    pulling: 'Pull to refresh',
    armed: 'Release to refresh',
    refreshing: 'Refreshing…',
};

export default function PullToRefreshIndicator({ state, label = 'list' }) {
    if (!state?.active) return null;
    const { phase = 'idle', distance = 0 } = state;
    const words = WORDS[phase] || '';
    return (
        <>
            <div
                className="ia-ptr"
                data-pull-phase={phase}
                data-pull-to-refresh={label}
                style={{ height: `${Math.max(0, distance)}px` }}
                aria-hidden="true"
            >
                {phase !== 'idle' && (
                    <span className="ia-ptr__pill">
                        <span className={`ia-ptr__icon${phase === 'refreshing' ? ' is-spinning' : ''}${phase === 'armed' ? ' is-armed' : ''}`} aria-hidden="true">↻</span>
                        <span>{words}</span>
                    </span>
                )}
            </div>
            <span className="sr-only" role="status" aria-live="polite" data-pull-status={label}>
                {phase === 'refreshing' ? `Refreshing the ${label}…` : ''}
            </span>
        </>
    );
}
